import axios from 'axios';
import { StorageService } from '../../service/Storage';
import { API_END_POINT } from '../index';
import { ggSentry } from '../sentry';
export const V3_API_END_POINT = API_END_POINT + '/v3';
export const apiAxios = axios.create({
  baseURL: API_END_POINT + '/v1',
  timeout: 120000,
});
export const apiAxiosV2 = axios.create({
  baseURL: API_END_POINT + '/v2',
  timeout: 120000,
});

export const apiAxiosV2_1 = axios.create({
  baseURL: API_END_POINT + '/v2.1',
  timeout: 120000,
});
export const apiAxiosAutoLogin = axios.create({
  baseURL: API_END_POINT + '/v1',
  timeout: 120000,
});
apiAxios.interceptors.request.use(addTokenInterceptor);
apiAxios.interceptors.response.use(responseInterceptor, processNetworkErrors);

apiAxiosV2.interceptors.request.use(addTokenInterceptor);
apiAxiosV2.interceptors.response.use(responseInterceptor, processNetworkErrors);

apiAxiosV2_1.interceptors.request.use(addTokenInterceptor);
apiAxiosV2_1.interceptors.response.use(
  responseInterceptor,
  processNetworkErrors
);

apiAxiosAutoLogin.interceptors.request.use(addTokenInterceptor);
apiAxiosAutoLogin.interceptors.response.use(
  responseInterceptor,
  processNetworkErrorsNoRedirect
);

function addTokenInterceptor(config) {
  const headers = config.headers || {};
  const accessToken = StorageService.getAccessToken();
  // const xpn = StorageService.getXPN();
  // const xpn = 'com.Chillar Pro .earncoins.moneymaker';
  const xpn = process.env.REACT_APP_XPN;
  if (accessToken) headers['auth-token'] = accessToken;
  headers['x-pn'] = xpn;

  config.headers = headers;
  return config;
}

function responseInterceptor(config) {
  return config;
}

async function processNetworkErrors(err) {
  if (
    err.response?.data?.err_code === 1003 ||
    err.response?.data?.err_code === 1004
  ) {
    throw err.response;
  }
  if (err.response?.status === 403) {
    StorageService.setAccessToken();
    StorageService.setRefreshToken();
    StorageService.setWId();
    StorageService.setUserId();
    window.location.href = '/';
  }
  return await handleTokenExpire(err);
}
async function processNetworkErrorsNoRedirect(err) {
  if (
    err.response?.data?.err_code === 1003 ||
    err.response?.data?.err_code === 1004
  ) {
    throw err.response;
  }
  if (err.response?.status === 403) {
    StorageService.setAccessToken();
    StorageService.setRefreshToken();
    StorageService.setWId();
    StorageService.setUserId();
  }
  return await handleTokenExpire(err);
}
async function handleTokenExpire(err) {
  const shouldRetry = isTokenExpired(err);

  if (shouldRetry) {
    const token = await getNewAccessToken();
    if (token.data?.error_code === 1003 || token.data?.error_code === 1004) {
      throw token;
    }
    err.config.headers['auth-token'] = token;
    return new Promise(resolve => {
      setTimeout(() => {
        err.config.__retryCount = (err.config.__retryCount || 0) + 1;
        return resolve(axios(err.config));
      }, 1000);
    });
  } else {
    if (err?.response?.status !== 403) {
      ggSentry.catchExceptions(err);
    }
    return Promise.reject(err);
  }
}

function isTokenExpired(error) {
  if (!error.config) return false;
  const isTokenExpired = error.response?.status === 401;
  return isTokenExpired;
}

const getNewAccessToken = withProtectedTask(async () => {
  const res = await apiAxios.post('/user/token/refresh', {
    refresh_token: StorageService.getRefreshToken(),
  });
  if (res.data?.error_code === 1003 || res.data?.error_code === 1004) {
    return res;
  }

  StorageService.setAccessToken(res.data.access_token);
  StorageService.setRefreshToken(res.data.refresh_token);
  return res.data.access_token;
});

/**
 * @template T
 * @param {{ (): Promise<T> }} fn
 * @returns  {Promise<any>}
 *
 * I don't know why I made this unstable.
 */
export function withProtectedTask(fn) {
  const cachedPromise = {};

  return function wrapper() {
    const hasArgs = !!arguments.length;
    const hash = arguments.length ? getObjectHash(arguments) : '__DEFAULT__';

    if (hasArgs) {
      // Not fully tested.
      console.warn(
        /** BTW, I'm using in prod 😅😂 */
        '[unsafe_withProtectedTask] Be careful if you are willing to use in production...'
      );
    }

    if (cachedPromise[hash]) {
      console.log('reusing existing network call.');
      return cachedPromise[hash];
    }

    cachedPromise[hash] = fn
      .apply(null, arguments)
      .then(data => {
        cachedPromise[hash] = null;
        return data;
      })
      .catch(err => {
        cachedPromise[hash] = null;
        return Promise.reject(err);
      });

    return cachedPromise[hash];
  };
}

function getObjectHash(obj) {
  //bechmark: https://codesandbox.io/s/getobjecthash-m78qb?file=/src/index.js
  return JSON.stringify(obj);
}
